<h1 mat-dialog-title>Approve Draft</h1>
<mat-dialog-content>
  <h3>{{ approveDraftMsg }}</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="buttons">
    <button mat-flat-button mat-dialog-close>Cancel</button>
    <button
      mat-raised-button
      class="ms-2"
      color="primary"
      (click)="onApprove()"
    >
      Approve
    </button>
  </div>
</mat-dialog-actions>
